export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: `無限制`,
    },
    {
      value: 0,
      name: "Today",
      text: `當日`,
    },
    {
      value: 1,
      name: "Customize",
      text: `自訂日期`,
    },
  ];
}
